import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=2463e5f2&scoped=true&"
import script from "./TopicCard.vue?vue&type=script&lang=js&"
export * from "./TopicCard.vue?vue&type=script&lang=js&"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=2463e5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463e5f2",
  null
  
)

export default component.exports